/*
 * Copyright © 2021 Firecrest Clinical, Ltd.
 * All rights reserved.
*/

import * as Commands from '../../commands';
import {ToggleCommand} from '../../commands/types';

export const ToggleCommands: Record<string, ToggleCommand> = {
    bold: Commands.STRONG,
    italic: Commands.EM,
    code: Commands.CODE,
    underline: Commands.UNDERLINE,
    strike: Commands.STRIKE,
    blockquote: Commands.BLOCKQUOTE,
    bullet_list: Commands.UL,
    ordered_list: Commands.OL,
    h1: Commands.H1,
    h2: Commands.H2,
    h3: Commands.H3,
    h4: Commands.H4,
    h5: Commands.H5,
    h6: Commands.H6,
    fontSize8: Commands.FONT_SIZE_8,
    fontSize9: Commands.FONT_SIZE_9,
    fontSize10: Commands.FONT_SIZE_10,
    fontSize11: Commands.FONT_SIZE_11,
    fontSize12: Commands.FONT_SIZE_12,
    fontSize13: Commands.FONT_SIZE_13,
    fontSize14: Commands.FONT_SIZE_14,
    fontSize15: Commands.FONT_SIZE_15,
    fontSize16: Commands.FONT_SIZE_16,
    fontSize17: Commands.FONT_SIZE_17,
    fontSize18: Commands.FONT_SIZE_18,
    fontSize19: Commands.FONT_SIZE_19,
    fontSize20: Commands.FONT_SIZE_20,
    fontSize21: Commands.FONT_SIZE_21,
    fontSize22: Commands.FONT_SIZE_22,
    fontSize23: Commands.FONT_SIZE_23,
    fontSize24: Commands.FONT_SIZE_24,
    align_left: Commands.ALIGN_LEFT,
    align_center: Commands.ALIGN_CENTER,
    align_right: Commands.ALIGN_RIGHT,
    align_justify: Commands.ALIGN_JUSTIFY
};

export const Link = Commands.LINK;
export const Image = Commands.IMAGE;
export const TextColor = Commands.TEXT_COLOR;
export const TextBackgroundColor = Commands.TEXT_BACKGROUND_COLOR;
